import { render, staticRenderFns } from "./travel2.vue?vue&type=template&id=176c9388&"
import script from "./travel2.vue?vue&type=script&lang=js&"
export * from "./travel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports